import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      marginTop: "3rem",
    }
  })
);

interface Props {
  children: any;
}

const Paper:React.FC<Props> =  ({children}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {children}
    </div>
  );
}

export default Paper;